import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'

export const ModalContainer = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9002;
`

interface propsType {
  children: React.ReactNode
}

const ModalTest: React.FC<propsType> = ({children}) => {
  const [portalElement] = useState(() => document.createElement('div'))

  useEffect(() => {
    console.log('🐞 [BaseModal] mount', {
      portalElement,
      modalContainerZIndex: 9002,
      expectedStyle: {
        position: 'fixed',
        inset: '0',
        background: 'rgba(0, 0, 0, 0.5)'
      }
    })

    document.body.appendChild(portalElement)

    return () => {
      console.log('🐞 [BaseModal] unmount')
      document.body.removeChild(portalElement)
    }
  }, [portalElement])

  return ReactDOM.createPortal(
    <ModalContainer data-testid="base-modal-container">
      {children}
    </ModalContainer>,
    portalElement
  )
}

export default ModalTest